var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_152",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H79.5V79.5H0.5V0.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 26.6667C62.6522 26.6667 65.1957 27.7203 67.0711 29.5957C68.9464 31.471 70 34.0146 70 36.6667C70 39.3189 68.9464 41.8625 67.0711 43.7378C65.1957 45.6132 62.6522 46.6667 60 46.6667",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.334 26.6667V63.3335C33.334 64.2176 32.9828 65.0653 32.3577 65.6904C31.7326 66.3156 30.8847 66.6667 30.0007 66.6667H26.6673C25.7833 66.6667 24.9354 66.3156 24.3103 65.6904C23.6852 65.0653 23.334 64.2176 23.334 63.3335V46.6667",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26.6666L55.08 14.0999C55.5182 13.7349 56.0513 13.5024 56.6169 13.4296C57.1825 13.3568 57.7572 13.4467 58.2735 13.6887C58.7898 13.9308 59.2265 14.3151 59.5323 14.7964C59.838 15.2778 60.0003 15.8363 60 16.4066V56.9266C60.0003 57.4968 59.838 58.0554 59.5323 58.5367C59.2265 59.0181 58.7898 59.4023 58.2735 59.6444C57.7572 59.8865 57.1825 59.9764 56.6169 59.9036C56.0513 59.8307 55.5182 59.5982 55.08 59.2332L40 46.6666H13.3333C12.4493 46.6666 11.6014 46.3154 10.9763 45.6903C10.3512 45.0651 10 44.2173 10 43.3332V29.9999C10 29.1159 10.3512 28.268 10.9763 27.6429C11.6014 27.0178 12.4493 26.6666 13.3333 26.6666H40Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/Icon8.271b1f42ef825982d31212ea041a4d7e.svg";
export { ForwardRef as ReactComponent };